import { api } from "./apiClient";

/**
 * Project-scoped RAG QA endpoint:
 * POST /projects/{projectId}/rag/qa
 * body: { question: string }
 * response: { answer: string, is_confident: boolean, used_chunks: [] }
 */
export const ragAPI = {
  askQuestion(projectId, question) {
    const q = (question ?? "").toString().trim();
    if (!projectId) {
      return Promise.reject(new Error("projectId is required for RAG QA"));
    }
    if (!q) {
      return Promise.reject(new Error("Question cannot be empty"));
    }

    return api.post(`/projects/${projectId}/rag/qa`, { question: q });
  },
};
